import React from 'react';
import classNames from 'classnames';
import { Form as FinalForm } from 'react-final-form';

import { injectIntl } from '../../util/reactIntl';
import { Form, FieldTextInput, SecondaryButton, Button } from '../../components';

import css from './SignupProviderForms.css';

const SignupProviderLinksForm = props => {
  return (
    <FinalForm
      {...props}
      render={formRenderProps => {
        const {
          rootClassName,
          className,
          handleSubmit,
          onPrev,
          form,
          intl,
          invalid,
          isModal,
          pristine,
        } = formRenderProps;

        const classes = classNames(rootClassName || css.root, className);

        const submitDisabled = invalid;
        const modalSubmitDisabled = invalid || pristine;

        const heading = intl.formatMessage({ id: 'SignupProviderForms.linksHeading' });
        const description = intl.formatMessage({ id: 'SignupProviderForms.linksDescription' });

        const websitePlaceholder = intl.formatMessage({
          id: 'SignupProviderForms.linksWebsitePlaceholder',
        });
        const linkedinPlaceholder = intl.formatMessage({
          id: 'SignupProviderForms.linksLinkedInPlaceholder',
        });

        const websiteLabel = intl.formatMessage({ id: 'SignupProviderForms.linksWebsiteLabel' });
        const linkedinLabel = intl.formatMessage({ id: 'SignupProviderForms.linksLinkedInLabel' });

        const nextButtonText = intl.formatMessage({
          id: 'SignupProviderForms.nextUpEducation',
        });
        const previousButtonText = intl.formatMessage({ id: 'SignupProviderForms.previousButton' });
        const okButtonText = intl.formatMessage({ id: 'SignupProviderForms.okButton' });

        return (
          <div className={classes}>
            <Form className={css.form} onSubmit={values => handleSubmit(values, form)}>
              <div className={css.formFieldsContainer}>
                <h2 className={css.mainHeading}>{heading}</h2>
                <div className={css.column}>
                  <p className={css.description}>{description}</p>
                  <FieldTextInput
                    type="text"
                    id="website"
                    name="website"
                    maxLength="100"
                    placeholder={websitePlaceholder}
                    label={websiteLabel}
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        if (!invalid) {
                          // Submit the form
                          handleSubmit(form.getState().values, form);
                        }
                      }
                    }}
                  />
                  <FieldTextInput
                    type="text"
                    id="linkedIn"
                    name="linkedIn"
                    maxLength="100"
                    placeholder={linkedinPlaceholder}
                    label={linkedinLabel}
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        if (!invalid) {
                          // Submit the form
                          handleSubmit(form.getState().values, form);
                        }
                      }
                    }}
                  />
                </div>
              </div>
              <div className={css.submitContainer}>
                {!isModal && (
                  <SecondaryButton rootClassName={css.backButton} type="button" onClick={onPrev}>
                    {previousButtonText}
                  </SecondaryButton>
                )}
                {!isModal ? (
                  <Button rootClassName={css.nextButton} type="Submit" disabled={submitDisabled}>
                    {nextButtonText}
                  </Button>
                ) : null}
                {isModal ? (
                  <div className={css.submitContainerModal}>
                    <Button
                      rootClassName={css.nextButton}
                      type="Submit"
                      disabled={modalSubmitDisabled}
                    >
                      {okButtonText}
                    </Button>
                  </div>
                ) : null}
              </div>
            </Form>
          </div>
        );
      }}
    />
  );
};

SignupProviderLinksForm.defaultProps = {
  isModal: false,
};

export default injectIntl(SignupProviderLinksForm);
